module.exports = __webpack_public_path__ + "media/images/city/095-split-point-lighthouse-17fe3e49b05d773ef7d5b404afb1b0ce.svg";